import component from "./ProfileAttentionFinished.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileAttentionFinished"

export default wrapVueComponent(componentName, component)
